import React, { useEffect } from 'react'
import Header from './Header'
import Footer from './Footer'
import { useParams } from 'react-router-dom'
import { unSubscribe } from '../Logic/index01'

const Unsbscribe = () => {

  const {e} = useParams();

  useEffect(() => {
      unSubscribe(e);
  },[]);



  return (
    <> 
    <Header/>
      <div class="bg-slate-900 text-white rounded-2xl p-6 mt-40 mb-10 ml-10 mr-10 lg:m-20 lg:mt-40 lg:ml-10 lg:mr-10">
        <p class="text-xs uppercase tracking-widest text-amber-300 font-semibold mb-2">You have unsubscribed from our monthly security tip and newsletter.</p>
        <p class="text-sm text-slate-200 leading-relaxed">
          Beeppee is a technology platform and not an emergency-response organization. Do not rely solely
          on Beeppee for emergency response, medical assistance, law-enforcement response, personal
          protection, theft prevention or recovery of a person or property. Where immediate assistance is
          required, contact the appropriate emergency or professional service.
        </p>
      </div>
    <Footer/>      
    </>
  )
}

export default Unsbscribe
